"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
// eslint-disable-next-line no-undef
if (quiz == null || quiz == undefined) {
  throw "No quiz object found.";
}

// eslint-disable-next-line no-undef
var _quiz = quiz,
  questions = _quiz.questions,
  notes = _quiz.notes;
var currentQuestionIndex = -1;
var quizSteps = document.querySelectorAll(".quiz-step");
var quizAnswers = document.querySelectorAll(".quiz-answer");
var quizButtons = document.querySelector(".quiz-buttons");
var _ref = _toConsumableArray(quizButtons.children),
  prevQuestion = _ref[0],
  nextQuestion = _ref[1];
var startButton = document.querySelector("#startQuiz");
if (!startButton) {
  throw "Couldn't find start button";
}
var renderQuiz = function renderQuiz() {
  var currentStep = currentQuestionIndex == -1 ? "start" : currentQuestionIndex >= questions.length ? "end" : currentQuestionIndex;
  quizSteps.forEach(function (step) {
    var activeStep = step.id == "quiz-step-".concat(currentStep);
    step.classList[activeStep ? "remove" : "add"]("hidden");
  });
  prevQuestion.disabled = currentQuestionIndex <= 0;
  if (typeof currentStep == "number") {
    quizButtons.classList.remove("hidden");
    nextQuestion.disabled = questions[currentQuestionIndex].answers.find(function (answer) {
      return answer.selected == true;
    }) == undefined;
  } else {
    quizButtons.classList.add("hidden");
    if (currentStep == "end") {
      var points = questions.reduce(function (prev, question) {
        var points = question.answers.find(function (answer) {
          return answer.selected;
        }).points;
        return prev + points;
      }, 0);
      var usedNotes = [];
      questions.forEach(function (q) {
        var _q$answers$find;
        var answer = (_q$answers$find = q.answers.find(function (a) {
          return a.selected;
        })) === null || _q$answers$find === void 0 ? void 0 : _q$answers$find.noteName;
        if (typeof answer === "string") {
          usedNotes.push(answer);
        } else if (Array.isArray(answer)) {
          usedNotes.push.apply(usedNotes, _toConsumableArray(answer));
        }
      });
      var noteNames = usedNotes.filter(function (value, index, self) {
        return self.indexOf(value) === index;
      });
      var noteMessage = "";
      notes.forEach(function (note) {
        if (!noteNames.includes(note.name)) {
          return;
        }
        if (noteMessage !== "") {
          noteMessage = noteMessage + " ";
        }
        noteMessage = "" + noteMessage + note.note;
      });
      var textElement = document.querySelector("#quiz-step-end > div");
      textElement.innerHTML = "\n      <h2>Resultat</h2>\n      <p>\n        Baseret p\xE5 dine svar, vil prisen v\xE6re <b>".concat(points.toLocaleString("da-DK"), " kr.</b> ").concat(noteMessage, "\n      </p>\n      <p>\n        Ovenst\xE5ende er en fastpris beregning, men hvis der skulle v\xE6re arbejde som skal udf\xF8res f\xF8rend at fx \xE5rsrapporten \n        kan indsendes, s\xE5 vil vi automatisk give besked om dette. Det er vigtigt for os, at vores kunder er tilfredse med \n        vort arbejde, samtidig som det ogs\xE5 er vigtigt for os, at vores arbejde foreg\xE5r t\xE6t sammen med kunderne.\n      </p>\n      <p>\n        Dette er et billigt produkt, hvor revisor ikke g\xF8r andet end at hj\xE6lpe dig som erhvervsdrivende men hvis du \xF8nsker \n        en p\xE5tegning eller erkl\xE6ring fra revisor omkring det udf\xF8rte arbejde, s\xE5 kan vi tage en samtale omkring dette. Og \n        det er selvf\xF8lgelig til en anden pris, idet b\xE5de vort arbejde og vort ansvar er langt st\xF8rre.\n      </p>\n      ");
    }
  }
};
startButton.addEventListener("click", function () {
  currentQuestionIndex = 0;
  renderQuiz();
});
prevQuestion.addEventListener("click", function () {
  currentQuestionIndex--;
  renderQuiz();
});
nextQuestion.addEventListener("click", function () {
  currentQuestionIndex++;
  renderQuiz();
});
quizAnswers.forEach(function (answer) {
  answer.addEventListener("change", function (e) {
    var _e$target$id$split$ma = e.target.id.split("-").map(function (x, i) {
        return i == 0 ? null : parseInt(x);
      }),
      _e$target$id$split$ma2 = _slicedToArray(_e$target$id$split$ma, 3),
      questionIndex = _e$target$id$split$ma2[1],
      answerIndex = _e$target$id$split$ma2[2];
    questions[questionIndex].answers.map(function (answer, i) {
      answer.selected = i == answerIndex;
      return answer;
    });
    renderQuiz();
  });
});
//# sourceMappingURL=quiz.js.map